// extracted by mini-css-extract-plugin
module.exports = {"SocialIcon":"Settings_SocialIcon__3pGZc","InputGroupText":"Settings_InputGroupText__3B03F"};